import { render } from "./statusBadge.vue?vue&type=template&id=d5328d82&scoped=true&ts=true"
import script from "./statusBadge.vue?vue&type=script&lang=ts"
export * from "./statusBadge.vue?vue&type=script&lang=ts"

import "./statusBadge.vue?vue&type=style&index=0&id=d5328d82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5328d82"]])

export default __exports__